// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NounImageVoteTable_wrapper__TMwqB"};